// extracted by mini-css-extract-plugin
module.exports = {"Selector":"Selector--2UgxV","InfoButton":"InfoButton--1NGIM","Info":"Info--IcevK"};